import { render, staticRenderFns } from "./QuestionType6.vue?vue&type=template&id=8df3a7b0&scoped=true"
import script from "./QuestionType6.vue?vue&type=script&lang=js"
export * from "./QuestionType6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df3a7b0",
  null
  
)

export default component.exports